<eds-panel edsSpacing="xxl" class="profie">
  <div>
    <eds-title size="h1" edsSpacing="sm" [isLight]="true" theme="primary">{{
      investmentTeam?.managerName
    }}</eds-title>
    <p
      class="text-dark-grey"
      edsSpacing="sm"
      [innerHTML]="investmentTeam?.managerDesignation"
    ></p>
    <eds-title size="h5" edsSpacing="md" [isLight]="true" theme="primary">{{
      summaryLabel
    }}</eds-title>
    <ng-container
      *ngIf="(isHandheld$ | async) === true"
      [ngTemplateOutlet]="investmentTeamPanel"
    >
    </ng-container>
    <div
      edsFlexbox
      justifyContent="space-between"
      [flexDirection]="(isHandheld$ | async) ? 'column' : 'row-reverse'"
      edsPadding
      edsPaddingTop="md"
    >
      <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '3' }" edsSpacing="md">
        <eds-image
          *ngIf="investmentTeam?.profile?.profileImage?.widenAsset?.url"
          [imgSrc]="investmentTeam?.profile?.profileImage?.widenAsset?.url"
          imgFallbackSrc="/assets/images/ben_head.png"
          altText="profile image"
          className="img--full-width"
        >
        </eds-image>
      </div>
      <div edsCol [columnNumbers]="{ s: '4', m: '8', l: '6' }">
        <div>
          <ng-container
            *ngIf="(isHandheld$ | async) === false"
            [ngTemplateOutlet]="investmentTeamPanel"
          >
          </ng-container>
        </div>
        <div
          edsPadding
          edsPaddingTop="md"
          [innerHTML]="investmentTeam?.profile?.content?.content"
        ></div>
      </div>
    </div>
  </div>
</eds-panel>
<ng-template #investmentTeamPanel>
  <eds-panel
    theme="light"
    [hasPadding]="true"
    [hasBorders]="true"
    *ngIf="showInvestmentTeamPanel"
  >
    <div edsGrid>
      <div
        *ngIf="isStandardOrLargeDesktop"
        edsSubGrid="layout-0"
        edsSubGridDesktop="layout-1"
        edsSubGridDesktopLarge="layout-1"
      >
        <div *ngIf="investmentTeam?.profile?.designations">
          <div edsRow>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm">{{ designationsLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p
                edsSpacing="sm"
                class="bold"
                edsPadding
                [edsPaddingRight]="(isHandheld$ | async) ? 'none' : 'lg'"
              >
                {{ investmentTeam?.profile?.designations }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.yearsInIndustry">
          <div edsRow>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm">{{ timeInIndustryLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p
                edsSpacing="sm"
                class="text-align-left bold"
                edsPadding
                [edsPaddingRight]="(isHandheld$ | async) ? 'none' : 'lg'"
              >
                {{ investmentTeam?.yearsInIndustry }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.profile?.teamOrSim">
          <div edsRow>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm">{{ teamOrSimLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm" class="bold">
                {{ investmentTeam?.profile?.teamOrSim }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.profile?.timeInFund">
          <div edsRow>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm">{{ timeInFundLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm" class="bold">
                {{ investmentTeam?.profile?.timeInFund }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.managerCity">
          <div edsRow>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm">{{ locationLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ l: 5 }">
              <p edsSpacing="sm" class="bold">
                {{ investmentTeam?.managerCity }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isStandardOrLargeDesktop" edsSubGrid="layout-0">
        <div *ngIf="investmentTeam?.profile?.designations">
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 4 }">
              <p edsSpacing="sm">{{ designationsLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 5 }">
              <p
                edsSpacing="sm"
                class="bold"
                edsPadding
                [edsPaddingRight]="(isHandheld$ | async) ? 'none' : 'lg'"
              >
                {{ investmentTeam?.profile?.designations }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.yearsInIndustry">
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 4 }">
              <p edsSpacing="sm">{{ timeInIndustryLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 5 }">
              <p
                edsSpacing="sm"
                class="text-align-left bold"
                edsPadding
                [edsPaddingRight]="(isHandheld$ | async) ? 'none' : 'lg'"
              >
                {{ investmentTeam?.yearsInIndustry }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.profile?.teamOrSim">
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 4 }">
              <p edsSpacing="sm">{{ teamOrSimLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 5 }">
              <p edsSpacing="sm" class="bold">
                {{ investmentTeam?.profile?.teamOrSim }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.profile?.timeInFund">
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 4 }">
              <p edsSpacing="sm">{{ timeInFundLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 5 }">
              <p edsSpacing="sm" class="bold">
                {{ investmentTeam?.profile?.timeInFund }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="investmentTeam?.managerCity">
          <div edsRow>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 4 }">
              <p edsSpacing="sm">{{ locationLabel }}:</p>
            </div>
            <div edsCol [columnNumbers]="{ s: 2, m: 2, l: 5 }">
              <p edsSpacing="sm" class="bold">
                {{ investmentTeam?.managerCity }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </eds-panel>
</ng-template>
